<template>
  <div class="section-hotels">
    <div class="title">
      <y-text size="36px">{{ t("shell.home.hotels.title") }}</y-text>
    </div>
    <!-- centeredSlides="true" -->
    <swiper
      :modules="[Scrollbar, EffectCoverflow]"
      :grabCursor="true"
      :scrollbar="{
        el: '.hotel-scrollbar',
        hide: true,
        draggable: true
      }"
      slidesPerView="auto"
      :coverflowEffect="{
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false
      }"
      :initial-slide="0"
    >
      <swiper-slide v-for="(item, index) in hotels" :key="index">
        <hotel-card
          :hotel="item"
          class="ml-[10px]"
          @select="handleSelectHotel(item)"
        />
      </swiper-slide>
    </swiper>
    <div class="hotel-scrollbar" />
  </div>
</template>

<script setup>
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/effect-coverflow";

import HotelCard from "@packages/booking/hotel/HotelCard/V2.vue";
import { storeToRefs } from "pinia";
import { EffectCoverflow, Scrollbar } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import { computed, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";
import { useHotelStoreHook } from "@/distributions/consumer/y/store/hotel";
import { syncHotelDetailLocation } from "@/distributions/consumer/y/utils/hotelNavigation";
import { useHotels } from "@/hooks/useHotels";
import { useUserStoreHook } from "@/store/modules/user";

const { t } = useI18n();
const store = useHotelStoreHook();
const channelStore = useYChannelStoreHook();
const userStore = useUserStoreHook();
const { searchModel } = storeToRefs(store);
const { language, preferred } = storeToRefs(userStore);
const router = useRouter();

const HOTEL_LIST = [
  "5b50e50312bd3f60197ea5a2",
  "640053d58a90213b2bce0432",
  "5b35e43e04f832fae1e4d9ee",
  "603fcfaa6239d56c4813a9c4"
];

const hotelIdList = computed(() => {
  return channelStore.configs?.pages?.Index?.featuredHotels || HOTEL_LIST;
});

const { hotels, fetchHotels } = useHotels({
  stay: searchModel.value.stay,
  filter: {
    hotels: hotelIdList.value.map(item => {
      return { _id: item };
    })
  },
  preferred: preferred.value
});

const handleSelectHotel = item => {
  store.SET_SELECTED_HOTEL(item);
  const locationQuery = syncHotelDetailLocation(store, item, language.value);
  router.push({
    path: "/hotel/detail",
    query: {
      ...locationQuery,
      checkIn: store.searchModel.stay.date.checkIn,
      checkOut: store.searchModel.stay.date.checkOut,
      numberOfAdults: store.searchModel.stay.guest.numberOfAdults,
      numberOfChildren: store.searchModel.stay.guest.numberOfChildren,
      numberOfRooms: store.searchModel.stay.guest.numberOfRooms,
      hotelId: item._id
    }
  });
};

watch(language, () => {
  searchModel.value.preferred.language = language.value;
});

onMounted(() => {
  fetchHotels();
});

defineOptions({
  name: "Hotels"
});
</script>

<style lang="scss" scoped>
.section-hotels {
  padding-bottom: 100px;
  margin: 0 auto;
  width: 1080px;
  .title {
    --y-text-font-family: var(--y-title-font);
    margin-top: 90px;
    font-size: 50px;
    color: var(--y-text-color);
    text-align: center;
    margin-bottom: 48px;
    line-height: 1;
  }

  .swiper-slide {
    --hotel-card-width: 443px;
    --hotel-card-img-height: 243px;
    width: 475px;
    padding-bottom: 56px;
    user-select: none;
    .item {
      height: 262px;
      background: #fcfbf6;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .icon {
        width: 128px;
      }

      .text {
        font-size: 28px;
        font-family: Barlow, Barlow;
        font-weight: 500;
        color: #816853;
        line-height: 36px;
        text-align: center;
      }
    }
  }

  .hotel-scrollbar {
    --swiper-scrollbar-drag-bg-color: #000;
    width: 1080px;
    margin: 0 auto;
    height: 6px;

    opacity: 1 !important;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 1px;
      background: #bfbfbf;
      left: 0;
      bottom: 0;
    }
  }
}
</style>
